export default "__VITE_ASSET__BsLE4$60__"